import { Check, Copy } from 'lucide-react';
import { useCopyToClipboard } from '@/hooks/multi-agent/useCopyToClipboard';

export function CodeSnippet({ code }: { code: string }) {
  const { copied, copy } = useCopyToClipboard();

  return (
    <div className="group relative mt-2 overflow-hidden rounded-md border border-border bg-muted/40">
      <pre className="nc-diff-scroll overflow-x-auto px-3 py-2 pr-9 text-xs">
        <code className="font-mono text-foreground">{code}</code>
      </pre>
      <button
        type="button"
        onClick={() => void copy(code)}
        aria-label="Copy command"
        className="absolute right-1.5 top-1.5 flex items-center gap-1 rounded px-1.5 py-1 text-[11px] text-muted-foreground opacity-0 transition-opacity hover:bg-muted hover:text-foreground focus-visible:opacity-100 group-hover:opacity-100"
      >
        {copied ? <Check className="h-3 w-3" /> : <Copy className="h-3 w-3" />}
      </button>
    </div>
  );
}
